<template>
  <SandalsCollectionPage />
</template>

<script setup lang="ts">
import SandalsCollectionPage from '../../sandals/index.vue'
</script>
